import {
  AttendanceDateType,
  Gender,
  HolidayRequestsStatus,
  HolidayScheduleType,
  MaritalStatus,
  Role,
  Status
} from './model';
import { SortTypeEnum } from 'api/generated';
import { EnumOptions } from 'ts-types';
import { fromEnum } from 'utils/enums';
import { splitPascalCase } from 'utils/strings';

export const roles: EnumOptions<typeof Role, string>[] = fromEnum(
  Role,
  ([label, value]: [keyof typeof Role, Role]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const statuses: EnumOptions<typeof Status, string>[] = fromEnum(
  Status,
  ([label, value]: [keyof typeof Status, Status]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const maritalStatuses: EnumOptions<typeof MaritalStatus, string>[] = fromEnum(
  MaritalStatus,
  ([label, value]: [keyof typeof MaritalStatus, MaritalStatus]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const genders: EnumOptions<typeof Gender, string>[] = fromEnum(
  Gender,
  ([label, value]: [keyof typeof Gender, Gender]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const holidayTypes: EnumOptions<typeof HolidayScheduleType, string>[] = fromEnum(
  HolidayScheduleType,
  ([label, value]: [keyof typeof HolidayScheduleType, HolidayScheduleType]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const attendanceDateType: EnumOptions<typeof AttendanceDateType, string>[] = fromEnum(
  AttendanceDateType,
  ([label, value]: [keyof typeof AttendanceDateType, AttendanceDateType]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const holidayRequestsStatus: EnumOptions<typeof HolidayRequestsStatus, string>[] = fromEnum(
  HolidayRequestsStatus,
  ([label, value]: [keyof typeof HolidayRequestsStatus, HolidayRequestsStatus]) => ({
    label: splitPascalCase(label),
    value
  })
);

export type SortType = SortTypeEnum;

export const holidayManualApprove = [HolidayScheduleType.Holiday];
